import { render, staticRenderFns } from "./Peanut.vue?vue&type=template&id=06d84224&"
import script from "./Peanut.vue?vue&type=script&lang=js&"
export * from "./Peanut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports